/// <reference path="../overrides.d.ts" />
import {L} from '../lt-ng/landcare-toolkit';
import {SearchService} from '../services/search';
import {LTServices} from '../lt-ng/lt-services';
import {_F} from '../utility/func';
import {PinAndExtras} from "../services/PinApi";
import {IMapShare, IMapShareData, IMapShareService} from "../services/MapShareAPI";
import {LTMap} from "../lt-ng/lt-directives";
import {IToast, IToastService} from "../services/ToastService";
import {IUsageLoggingService} from "../services/IUsageLoggingService";
import {MapClickInteraction} from "../lt-ng/map-interactions";
import {Interaction_Setting, ISettingsService} from "../services/settings";
import {ILtToolbarOptions} from "../utility/toolbar";
import {AppPane, IAppConfig} from "../services/app-config/app_config";
import {ICoordinateAdjustmentService} from "../services/coordinate-adjustment";
import {Panes} from "./panes";
import {GeoAppEvents} from "./events/geoapp_events";
import {IReportService} from "../services/features-api/report_service";
import {IFeatureState} from "../services/feature_state";
import is_touch_device = L.is_touch_device;
import getVisibleLayers = L.tree.getVisibleLayers;
import Item = L.tree.Item;
import paragraphise = _F.paragraphise;
import nodeIsScienceLayer = L.tree.nodeIsScienceLayer;
import getVisibleScienceLayers = L.tree.getVisibleScienceLayers;
import filterNodes = L.tree.filterNodes;
import isQueryAble = L.tree.isQueryAble;
import {ISavedFeatureService} from "../services/features-api/saved_features";
import {FeaturesEvents} from "../services/events/FeaturesEvents";
import elemToAppendModal = _F.elemToAppendModal;
import {ITourService} from "../services/ITourService";
import {IReportPresenter} from "../services/oe/report-presenter/IReportPresenter";
import someNodes = L.tree.someNodes;
import {MapOptions} from "ol/PluggableMap";
import {Map as OlMap, MapBrowserEvent} from "ol";
import {Coordinate} from "ol/coordinate";
import VectorLayer from "ol/layer/Vector";
import {transform} from "ol/proj";
import {Geometry, Point} from "ol/geom";
import Feature from "ol/Feature";
import {Layer} from "ol/layer";
import {ILayerTreeManipulationService} from "../services/oe/layer-tree-manipulation";
import {StateParams, StateService} from '@uirouter/angularjs';
import {IStateLayerParams, StateNames} from "../router/oe-layers-router";
import {ClassType, IBaseGeoAppScope} from "./IBaseGeoAppScope";
import {_t, sprintf} from "../utility/i18n";
import {CollectionEvent} from "ol/Collection";
import VectorSource from "ol/source/Vector";
import formatScale = _F.formatScale;
import {PinReport, ReportKind} from "../services/ISharedFeatureState";


export interface SearchItem {
	pxid?: string;
	value?: string;
	name?: string;
	x?: number;
	y?: number;
}

export interface ModalService {
	open(options?: {
		animation?: boolean;
		backdrop?: boolean | string;
		templateUrl?: string;
		component?: string;
		controller?: string | Function;
		size?: string;
		resolve?: any;
		scope?: any;
		appendTo?: any;
	}): void | any;
}

export interface IGeoAppScope extends IBaseGeoAppScope {
	showLayerSelectorPane: () => void;
	isBaseLayer: (node: L.tree.Item) => boolean;
	paneRightStyle: () => { overflow: string };
	paneLayerSelector: boolean;
	flattenedLayers: (nodes: L.tree.Item[]) => L.tree.Item[];
	getLegendString: () => string;
	nodeIsIncluded: (node: L.tree.Item) => boolean;
	checked: (node: L.tree.Item) => boolean;
	isIndeterminate: (node: L.tree.Item) => boolean;
	showDefaultLegendAndMetaData: (node: L.tree.Item) => void;
	deleteCard: { (id: number): void };
	center: L.IOlCenter;
	items: SearchItem[];
	wms: L.IOlWms;
	olDefaults: any;
	name: string;
	myMapOptions: MapOptions;
	map: OlMap;
	place: { name: string };
	places: string[];
	search: { value: string };
	people: any;
	treeOptions: any;
	dataForTheTree: any;
	selectPlace: (name: string) => void;
	showSelected: (node: L.tree.Item, selected: boolean, showLegend: boolean, silent?: boolean) => void;
	selectedNode: L.tree.Item;
	nodeToggle: (node: L.tree.Item) => void;
	zoomToScale: (scale: number) => void;
	expandedNodes: any[];
	scales: number[];
	currentScale: number;
	paneLeftCollapsed: boolean,
	paneBottomCollapse: boolean,
	paneRightCollapse: boolean,
	showPane: (AppPane) => void,
	showPaneMobile: (AppPane) => void,
	hidePane: (AppPane) => void,
	hidePaneMobile(pane: AppPane) : void;
	togglePane(pane: AppPane, isMobile?:boolean);
	activePane: AppPane,
	zoomTo: (coord: Coordinate) => void
	historyBack: ($event) => boolean;
	historyForward: ($event) => boolean;
	haveLegend: () => boolean;
	legend: {
		items: {
			shortName: string;
			longName?: string;
			iconUrl?: string;
			graphicUrl?: string;
		}[]
	};
	metadataNodes: Item[];
	haveMeta: () => boolean;
	isContext: () => boolean;
	meta: {
		items: any[]
		isContext: boolean;
	};
	createShare($event: any);
	activeShareURL() : string;
	activeMapShare? : IMapShare;
	processingLegend: boolean;
	closeSearch?: () => void;
	selectedLayers : {};
	cssClasses: () => any;
	activeToolbar: string;
	addPin($event: any): boolean;
	showModal: (view: string, mobile?: boolean, fullUrl?: boolean) => void;
	showTermsModal: () => void;
	showHelpModal($event?: any): boolean;
	showSettingsModal($event: any): boolean;
	toggleZoomMode($event: any): boolean;
	zoomMode: boolean;
	// toggleZoomMode();
	refreshPage($event): boolean;
	legendQueryItems: ClassType[];
	toolbarOptions: ILtToolbarOptions;
	noLoginNeeded?: boolean;
	closeSearchAndAccept?: () => void;
	showPrint?: boolean;
	doShowPrint: ($event: any) => boolean;
	hideElement: (selector: string) => void;
	browserSupported: () => boolean;
    isLoggedIn(): boolean;
    activePaneIcon(): string;
    togglePaneLeft()
    togglePaneBottom();
    togglePaneRight();
    layerClassMode(): string;
    selectedPin: PinAndExtras;
    savePins(): void;
    fullscreen: boolean;
    fullscreenIconClass(): string;
    resetMap($event): boolean;
    toggleFullscreen($event): boolean;
    hasFullScreen: boolean;
    hasHistoryBack(): boolean;
    hasHistoryForward(): boolean;
    modalType(): string;
    modalTitle(): string;
    lrisQueryStr(): string;
    paneContainerClasses(): {[cls: string]: boolean};
    pointQueryResult: any;
    activePaneTitle(): string;
    queryLoading: boolean;
    confirmPinLocation: () => void;
    reportId: string;
	highlightInput(selector: string, doCopy?: boolean);
	pointsInRHPane(): PinReport[];
	pointLayer: VectorLayer<VectorSource<Geometry>>;
	startTour();
	isTourLoading(): boolean;
}

export class GeoAppCtrl {
	public static $inject = [
		'$scope',
		'$http',
		'$timeout',
		'$rootScope',
		'$sce',
		'$location',
		'searchService',
		'landcareMapService',
		'$window',
		'$uibModal',
		'mapShareService',
		'toastService',
		'myQueryString.QueryString',
		'usageLoggingService',
		'settingsService',
		'$q',
		'appConfig',
		'coordinateAdjustmentService',
		'reportService',
		'featureState',
		'savedFeatureService',
		'tourService',
        'reportPresenterService',
		'layerTreeManipulationService',
		'$state',
		'$stateParams',
		'$transitions',
	];

	constructor(protected $scope: IGeoAppScope,
				protected $http: ng.IHttpService,
				protected $timeout: ng.ITimeoutService,
				$rootScope: ng.IRootScopeService,
				protected $sce: ng.ISCEService,
				protected $location: ng.ILocationService,
				searchService: SearchService,
				protected mapService: LTServices.IMapService,
				$window: ng.IWindowService,
				protected $uibModal: ModalService,
				protected mapShareService : IMapShareService,
				protected toastService : IToastService,
				protected qString: LTMap.IQueryString,
				protected usageLoggingService : IUsageLoggingService,
				protected settingsService : ISettingsService,
				protected $q : ng.IQService,
				protected appConfig: IAppConfig,
				protected coordinateAdjustmentService: ICoordinateAdjustmentService,
				protected reportService: IReportService,
				protected featureState: IFeatureState,
				protected savedFeatureService: ISavedFeatureService,
				protected tourService: ITourService,
                protected reportPresenterService: IReportPresenter,
				protected layerTreeManipulationService: ILayerTreeManipulationService,
				protected $state: StateService,
				protected $stateParams: StateParams) {

	    const emptyTree = [];
		angular.extend($scope, {
			get expandedNodes() {
				return layerTreeManipulationService.expandedNodes;
			},
			get dataForTheTree() {
				return layerTreeManipulationService.treeData || emptyTree;
			}
		});

		$scope.legendQueryItems = [];
		$scope.selectedLayers = {
			base: null
		};
		$scope.metadataNodes = [];
		let visibleScienceLayer = null;
		$scope.pointLayer = mapService.featuresLayer;

		$scope.pointsInRHPane = () => {
			const rp = featureState.getActiveReportIfMultiplePins();
			return rp ? rp.reports : [];
		};

		$scope['activeLayerId'] = () => {
			return filterNodes(mapService.treeData, isQueryAble)[0].id;
		};
		const showReport = (ev, reportId, requestEdit) => {
			$scope.reportId = reportId;
			this.reportPresenterService.showReportById(reportId, requestEdit);
		};

		$scope.$on('showFragReport',  showReport);

        const deregisterWatchTreeData = $scope.$watch('dataForTheTree', () => {
            const baseMaps = ($scope.dataForTheTree || []).filter((layerGroup) => layerGroup.checkBehavior == 'BASEMAP');
            const checkedBaseMap = baseMaps.length ? baseMaps[0].children.filter((m) => m.isChecked()) : [];
            if (checkedBaseMap.length) {
                $scope.selectedLayers['base'] = checkedBaseMap[0];
                deregisterWatchTreeData();
            }
        });

        $scope.$on(GeoAppEvents.layerToggled, (ev, node : L.tree.Item, extras = {}) => {
			if (!node) return;
			if (node.parent && node.parent.checkBehavior == 'BASEMAP') {
				$scope.selectedLayers['base'] = node;
			}

			const {showLegend} = (extras || { showLegend: undefined });

			if (showLegend) {
				this.showLegendAndMetaData(node);
				$scope.paneBottomCollapse = false;
			}
		});

		$scope.isLoggedIn = () => {
			return window['LTConfiguration']
				&& window['LTConfiguration']['userId'];
		};

		$scope.legend = {
			//have: false,
			items: []
		};
		$scope.processingLegend = false;

		$scope.$on('doAreaQuery', (/*ev, geom : Geometry*/) => {
			$scope.showPane(Panes.Ids.FEATURES);
		});

		$rootScope.$on(GeoAppEvents.displayShare, (ev, mapShareData : IMapShareData) => {
			if (mapShareData.geometryWKT) {
				$scope.showPane(Panes.Ids.FEATURES);
			}
			if (mapShareData.legend) {
				this.showLegendFromShare(mapShareData.legend);
			} else {
				this.showLegendAndMetaData();
			}
		});

		$scope.getLegendString = () => this.getLegendString();

		$scope.createShare = ($event: any) => {
			if ($event) $event.preventDefault();

			mapShareService.createShare(this.getLegendString()).then((mapShare : IMapShare) => {
				$scope.activeMapShare = mapShare;
				this.mapShareService.setActiveShare(mapShare);
				this.showShareModal();
			}).catch(e => {
				if (e.code === 403) {
					// not allowed
					console.warn("User not allowed to create a map share.", e.statusText);
				} else {
					console.warn("Unknown error:", e);
				}
			});
			return false;
		};

		$scope.$on('showShareModal', (ev, share : IMapShare) => {
			this.mapShareService.setActiveShare(share);
			if (share['GeometryWKT']) {
				this.showShareReportModal();
			} else {
				this.showShareModal();
			}
		});

		$scope.showModal = (modal: string,
							mobile: boolean = true,
							fullUrl: boolean = false) => this.showModal(modal, mobile, fullUrl);

		$scope.paneLayerSelector = !document.querySelector('.pane-collapse-layer-selector');

		if (window.sessionStorage.getItem('hideLayerSelector')) {
			$scope.paneLayerSelector = false;
			window.sessionStorage.removeItem('hideLayerSelector');
		}

		$scope.$watch('paneLayerSelector', () => {
			// we need to broadcast changes to the pane layer selector value
			$scope.$root.$broadcast('paneLayerSelector:change', $scope.paneLayerSelector);
		});

		let layerSelectorToggledByUser = false;
		const toggleLayerSelector = (onOrOff: boolean, fromUser: boolean = false) => {
			if (!onOrOff && layerSelectorToggledByUser && !fromUser) {
				return;
			}

			layerSelectorToggledByUser = layerSelectorToggledByUser ||  fromUser;
			// listen for requests to toggle the layer selector on or off
			$scope.paneLayerSelector = onOrOff;

			if (onOrOff) {
				this.$timeout(() => {
					const aButton = document.querySelector('.pane-meta-layer-selector button');
					if (aButton instanceof HTMLButtonElement) {
						aButton.focus();
					}
				}, 1);
			}
		}

		$scope.$on(GeoAppEvents.toggleLayerSelector, (ev, onOrOff, fromUser) => {
			// listen for requests to toggle the layer selector on or off
			toggleLayerSelector(onOrOff, fromUser !== undefined ? fromUser : true);
		});

		$scope.showLayerSelectorPane = () => toggleLayerSelector(true, true);
		$scope.showHelpModal = ($event?: any) => {
			if ($event) {

				$event.preventDefault();
			}
			$scope.modalTitle = () => "Help";
			this.showModal('/Partial/modal/Help', false, true, '/Partial/modal/Help');
			return false;
		};

		$scope.showTermsModal = () => {
			const partial = '/Partial/modal/Terms?segment=terms-of-use';
			this.showModal(partial, false, true, 'static'); // do not lose 'static' for the terms!
		};

		$scope.highlightInput = (selector, doCopy = false) => {
			const input = document.querySelector(selector);
			if (input instanceof HTMLInputElement) {
                const val = input.value;
                input.focus();
				input.selectionStart = 0;
				input.selectionEnd = val.length;

				if (doCopy) {
					try {
						document.execCommand('copy');
						input.blur();
					} catch (err) {
						console.warn(err);
					}
				}
			}
		};

		this.appConfig.initGeoApp($scope, this.mapService);

		$scope.showSettingsModal = ($event) => {
			if ($event) $event.preventDefault();
			$scope.modalTitle = () => "Settings";
			this.showModal('/Partial/settingsModal', false, true);
			return false;
		};

		$scope.$on('show-settings', $scope.showSettingsModal);

		$scope.activeShareURL = () => {
			if ($scope.activeMapShare) {
				return "/MapShare/byhash/" + $scope.activeMapShare.hash;
			}
			return "";
		};

        const isTouch = is_touch_device();

        let touchMode = settingsService.getInteractionMode();

		const updateUIOnTouchChange = () => {
			const touchEnabled = touchMode == 'touch';

			const viewport = document.querySelector('.landcare-openlayers-map > .ol-viewport');

			if (viewport instanceof HTMLElement) {
				viewport.classList.toggle('ol-touch', touchEnabled);
			}

			if (this.mapService.transparencySliderControl) {
                this.mapService.transparencySliderControl.toggleTouchMode(touchEnabled);
            }
		};

		$scope.$on('settings:interaction', (ev, newValue : Interaction_Setting) => {
			touchMode = newValue;
			updateUIOnTouchChange();
		});

		this.mapService.mapPromise.then(() => {
			updateUIOnTouchChange();
		});

		let pinHovered : boolean = false;
		$scope.$on("hoveredPin:change", (ev, args) => {
			pinHovered = !!(args && args['newValue']);
		});


		$scope.cssClasses = () => {
				let touch_on = isTouch; // auto by default
				if (touchMode == 'mouse') {
					touch_on = false;
				} else if (touchMode == 'touch') {
					touch_on = true;
				}

				return {
					touch:touch_on,
					"map-pin-hovered": pinHovered,
					"map-zoom-mode": !pinHovered &&  $scope.zoomMode,
					"print-hidden": !!$scope.reportId
				};
		};

		$scope.haveLegend = () => {
            const items = $scope.legend.items;
            return !!(items && items.length) || $scope.processingLegend;
		};
		$scope.meta = {
			items: [],
			isContext: false
		};
		$scope.haveMeta = () => {
            const items = $scope.meta.items;
            return !!(items && items.length);
		};
		$scope.lrisQueryStr = () => {
			const view = this.mapService.map && this.mapService.map.getView();
			if (!view) return '';

			return qString.toKeyValue({
				nc: '',
				c: transform(view.getCenter(), view.getProjection(), 'EPSG:4326')
					.reverse()
					.join(','),
				// adding 6 will result in a map that is slightly zoomed out of the current amount of zoom
				z: Math.min(14, view.getZoom() + 6),
				mt: 'OpenStreetMap'
			});
		};
		$scope.isContext = () => {
			return $scope.meta.isContext;
		};

		/**
		 * The following ensures the user stays logged in or is redirected.
		 * Turned off HTML5 mode! See modules/app-page.ts .
		 */
		function tick() {
			// in OE we do not want to log users out! See $ThemeDir/Layout/OurEnvironmentAppPage.ss
			if ($scope.noLoginNeeded) {
				return;
			}

			$http.get('/home/loggedIn?c=' + (new Date()).getTime()).then((data: any) => {
				if (!data.data.user && !data.data.userId) {
					// Sadly this doesn't work:
					//$location.path('/Security/login').search({'BackURL': $location.path()});
					(window['LTConfiguration'] || {})['userId'] = null;
					document.location.href = '/Security/login?BackURL=' + encodeURIComponent(document.location.pathname);
				}
				$timeout(tick, 5 * 60 * 1000); // 5 minutes
			});
		}

		$timeout(tick, 15 * 1000);

		$scope.paneLeftCollapsed = false;
		$scope.paneBottomCollapse = !!(document.querySelector('.pane-container.pane-collapse-bottom'));
		$scope.paneRightCollapse = false;

		$scope.paneContainerClasses = function() {
			return {
				"pane-container": true,
				"pane-collapse-left": $scope.paneLeftCollapsed,
				"pane-collapse-bottom": $scope.paneBottomCollapse,
				"pane-collapse-right": $scope.paneRightCollapse,
				"pane-collapse-sm": $scope.activePane == null,
				"pane-collapse-xs": $scope.activePane == null,
				"pane-collapse-print" : !$scope.showPrint,
				"pane-collapse-layer-selector" : !$scope.paneLayerSelector
			};
		};

        let panePopoverOpen: boolean = false;
		$scope.$on('chart-popover', (event, onOrOff) => {panePopoverOpen = onOrOff; });

		$scope.paneRightStyle = () => {
			return {
				'overflow':  panePopoverOpen ? 'visible' : null
			};
		};

		$scope.doShowPrint = ($event) => {
			if ($event) $event.preventDefault();
			this.mapService.detachMap();
			$scope.showPrint = true;
			return false;
		}

		$scope.$on(GeoAppEvents.closePrint, () => {
			this.mapService.attachMap();
			$scope.showPrint = false;
			/*this.mapService.mapPromise.then(map => map.updateSize());*/
		});

		$scope.activePaneIcon = () => {
			switch ($scope.activePane) {
				//case "Search": return 'icon icon-search';
				case "Layers": return 'icon icon-layers';
				case "Pins": return _t('App.ICON_PINS', 'icon icon-pins');
				case "SoilSummary": return 'icon icon-statistics';
				case "Properties": return 'icon icon-infographics';
				case "Metadata": return 'icon icon-price-tag';
				case "Overview": return 'icon icon-nz';
				case "Legend": return 'icon icon-map-legend';
				case "Features": return 'icon ' + _t('App.ADD_FEATURES_ICON', 'icon-report-doc');
				default: return null;
			}
		};
		const updateOverviewMapSizeInMs = (ms: number) => {
			setTimeout(() => {
				this.mapService.overviewLayer.getOverviewMap().updateSize();
			}, ms);
		};
		$scope.togglePaneLeft = () => {
			$scope.paneLeftCollapsed = !$scope.paneLeftCollapsed;
			updateOverviewMapSizeInMs(800);
		};
		$scope.togglePaneBottom = () => {
			$scope.paneBottomCollapse = !$scope.paneBottomCollapse;
			updateOverviewMapSizeInMs(800);
		};
		$scope.togglePaneRight = () => {
			$scope.paneRightCollapse = !$scope.paneRightCollapse;
			updateOverviewMapSizeInMs(800);
		};


		$scope.layerClassMode = () => this.settingsService.getLayerClassMode();

		$scope.selectedPin = null;

		const paneTitles = {
			"Layers": _t('App.LAYERS', "Layers"),
			"Pins": _t('App.MY_PINS', "My Pins"),
			"SoilSummary": _t('App.POINT_QUERY', "Soil summary"),
			"Legend": _t('App.LEGEND_PANE_TITLE', "Legend")
		};

		$scope.activePaneTitle = (): string => {
            const pane = $scope.activePane;
            if (paneTitles[pane]) {
				return paneTitles[pane];
			}

			if (pane) {
				// insert a space before all caps
				return pane.replace(/([A-Z])/g, ' $1')
				// uppercase the first character
					.replace(/^./, function(str) { return str.toUpperCase(); })
					.trim();
			}
			return "";
		};

        const paneOnOrOff = (pane: AppPane, onOrOff: boolean) => {
            const container = appConfig.getContainingPane(pane);
            if (container == null) {
                return;
            }
            if ($scope[container] === onOrOff) {
                $scope[container] = !onOrOff;
            }

            const label = onOrOff ? 'showPane' : 'hidePane';
            this.usageLoggingService.logWithAnalytics('GeoAppCtrl', label, pane);

            if (onOrOff) {
                $scope.activePane = pane;
            } else if (!onOrOff && $scope.activePane === pane) {
                $scope.activePane = null;
            }

            $scope.$root.$broadcast(Panes.Events.ACTIVE_CHANGED, $scope.activePane);

            if (!onOrOff && (pane === appConfig.pointQueryPane)) {
                // Dirty hack - if these panes are to be collapsed, then de-select any selected point queries
                this.featureState.deselectPins();
            }

            // let selectedNode: L.tree.Item = $scope.selectedNode;
            // if(pane === "Legend" && (selectedNode != null || selectedNode != undefined)) {
            //console.log('We are in legend pane and want to show legend and $scope.selectedNode.name is ' + $scope.selectedNode.name);
            // if (selectedNode.layerType === 'SCI_GROUP') {
            //this.showDefaultLegendAndMetaData($scope.selectedNode); // siamac: what is a better way to get the current node?
            // } else if(selectedNode.layerType === undefined) {
            //console.log('We want to find sci node from parent node and show legend');
            //this.showDefaultLegendAndMetaData(this.findParentNodeScienceLayer($scope, $scope.selectedNode.children));
            // }
            // }
        };

        $scope.showDefaultLegendAndMetaData = (node, showPane: boolean = true) => {
			$scope.showPane(Panes.Ids.Legend);
			if (showPane) this.showLegendAndMetaData(node);
		}

		$scope.activePane = null;
		$scope.showPane = (pane: AppPane) => paneOnOrOff(pane, true);

		$scope.hidePane = (pane: AppPane) => paneOnOrOff(pane, false);

		$scope.hidePaneMobile = (pane: AppPane) => {
			paneOnOrOff(pane, false);
			$rootScope.$broadcast(Panes.Events.CLOSE_MOBILE_PANE, pane);
		};

		$scope.$on(Panes.Events.SHOW_PANE, (ev, pane) => {
			$scope.showPane(pane);
		});

		$scope.$on(Panes.Events.HIDE_PANE, (ev, pane) => {
			$scope.hidePane(pane);
		});

		$scope.$on(Panes.Events.RESET_PANES, () => {
			$scope.paneLeftCollapsed = false;
			$scope.paneBottomCollapse = true;
			$scope.paneRightCollapse = true;
			$scope.activePane = undefined;
		});

		$scope.$on(Panes.Events.TOGGLE_PANE, (ev, pane, isMobile : boolean = false) => {
			if (isMobile && pane != appConfig.pointQueryPane && appConfig.deselectPinOnPaneClose) {
				featureState.deselectPins();
			}
			$scope.togglePane(pane, isMobile);
		});

		$scope.showPaneMobile = (pane : AppPane) => {
			if (pane != appConfig.pointQueryPane && appConfig.deselectPinOnPaneClose) {
				featureState.deselectPins();
			}
			$scope.showPane(pane);
		};

		$scope.$on('showPaneMobile', (ev, pane) => {
			$scope.showPaneMobile(pane);
		});

		if (appConfig.deselectPinOnPaneClose) {
			$scope.$watch('activePane', (newValue, oldValue) => {
				if (!newValue) {
					if (oldValue == appConfig.pointQueryPane || oldValue == "Properties") {
						// Dirty hack - if these panes are to be collapsed, then de-select any selected point queries
						featureState.deselectPins();
					}
				}
			});
		}

		$scope.togglePane = (pane: AppPane, isMobile : boolean = false) => {
			if (isMobile && pane == appConfig.pointQueryPane) {
				featureState.deselectPins();
			}
			// find the parent pane and toggle it
            const container = appConfig.getContainingPane(pane);
            $scope[container] = !$scope[container];
            const previousPane = $scope.activePane;
            $scope.activePane = previousPane === pane ? null : pane;

			$rootScope.$broadcast(Panes.Events.ACTIVE_CHANGED, $scope.activePane);

			if (isMobile && previousPane) {
				$rootScope.$broadcast(Panes.Events.CLOSE_MOBILE_PANE, previousPane);
			}
		};

		$scope['removePoint'] = (report) => featureState.removeReport(report);

		$scope['dismissPoint'] = (report) => {
			console.log('dismiss report', report);
			featureState.dismissReport(report);
		};

		$scope['savePointReport'] = (report: PinReport, changedProperties: string[] = undefined) => {
			savedFeatureService.saveFeature(report.userFeatures, changedProperties);
		};

		$scope['deletePoint'] = (report: PinReport) => {
			savedFeatureService.deleteFeature(report.userFeatures)
				.then(() => featureState.removeReport(report));
		};

		const unsavedPin = () => mapService.featuresLayer.getSource().getFeatures()
			.filter(f => f.getGeometry() instanceof Point)
			.filter(f => !f.get('saved'));


		$scope['unsavedPins'] = () => {
			return unsavedPin().length;
		};

		$scope.$on(GeoAppEvents.removeUnsavedPins, () => $scope['doRemoveUnsavedPins']());

		$scope['doRemoveUnsavedPins'] = () => {
			unsavedPin().forEach(f => {
					mapService.featuresLayer.getSource().removeFeature(f);
					$scope.$root.$broadcast(FeaturesEvents.featureRemoved, f, true);
				});
		};

		$scope['sharePointReport'] = (report: PinReport) => {
			const features = report.userFeatures.mapFeatures;
            const share = this.mapShareService.createFeaturesSharePaylod(features, '', ['pin']);

            this.mapShareService.createAreaReportShare(share)
				.then((result) => {
					$scope.$root.$broadcast('showShareModal', result);
				});
		};

		const queryPoint = (coordinate: Coordinate) => {
			featureState.addPointQuery(coordinate);
			$scope.showPane(appConfig.pointQueryPane);
		};

		$scope.$on(GeoAppEvents.queryPoint, (ev, coordinate) => queryPoint(coordinate));

		// passed into the lt-map directive via the map-click attribute
        const defaultMapClick = function (event: MapBrowserEvent<any>): boolean {
            let pointFound = false;

            event.map.forEachFeatureAtPixel(event.pixel, function (feature: Feature<Geometry>) {
                const maybePinReport = feature.get('pinReport');

                if ('kind' in maybePinReport && maybePinReport.kind === ReportKind.pin) {
                    $scope.showPane(appConfig.pointQueryPane);
                    featureState.selectPinReport(maybePinReport);
                }

                pointFound = true;

                $scope.$root.$broadcast(GeoAppEvents.featureClicked, feature);

                return true;
            }, <any>{
                layerFilter: (layer: Layer<any>) => layer === mapService.featuresLayer,
                hitTolerance: 10
            });

            if (!pointFound && appConfig.isSingleClickAddPin()) {
                queryPoint(event.coordinate);
                return true;
            }

            return !pointFound;
        };

        const clickInteraction = new MapClickInteraction({onClick: defaultMapClick});
        mapService.setDefaultClickInteraction(clickInteraction);

		$scope.activeToolbar = '';


		$scope.$on('show-add-pins', () => {
			console.log('show-add-pins');
			$scope.addPin(undefined);
		});
		$scope.zoomMode = false;
		$scope.toggleZoomMode = ($event) => {
			if ($event) $event.preventDefault();
			$scope.zoomMode = !$scope.zoomMode;
			return false;
		};

		$scope.$watch('zoomMode', () => {
			mapService.setDragZoom($scope.zoomMode);

		});

        const showToolbar = (toolbarOptions: ILtToolbarOptions, toolbarId: string) => {
            toolbarId = toolbarId || 'pins';
            if ($scope.toolbarOptions && $scope.toolbarOptions.onClose) {
                $scope.toolbarOptions.onClose();
            }
            $scope.toolbarOptions = toolbarOptions;
            $scope.activeToolbar = toolbarOptions ? toolbarId : null;
        };

        $scope.$on(GeoAppEvents.showToolbar, (ev, toolbarOptions : ILtToolbarOptions, toolbarId: string = null) => {
			showToolbar(toolbarOptions, toolbarId);
		});

		$scope.$on(GeoAppEvents.hideToolbar, () => {
			$scope.toolbarOptions = null;
			$scope.activeToolbar = null;
		});

		$scope.addPin = ($event) => {
			if ($event) $event.preventDefault();
			// make sure the map is in normal movement mode.
			$scope.showPane(Panes.Ids.FEATURES);
			featureState.toggleMode('pin', null);
			return false;
		};

		$scope.fullscreen = false;
		$scope.fullscreenIconClass = () => {
			return $scope.fullscreen || isFullscreen() ? 'icon icon-shrink' : 'icon icon-enlarge';
		};

		$scope.resetMap = ($event) => {
			if ($event) $event.preventDefault();
			$scope.$root.$broadcast(L.Events.OL_RESET_EXTENT, {
				detail: {
					padding: this.coordinateAdjustmentService.padding(),
					duration: 500
				}
			});
			return false;
		};

        const setupFs = (onOrOff: boolean) => {
            const elem = document.querySelector("main");
            if (onOrOff) {
                // on
                elem.classList.add('fullscreen');
            } else {
                elem.classList.remove('fullscreen');
            }
            return elem;
        };

        $scope.toggleFullscreen = ($event) => {
			if ($event) $event.preventDefault();
            const fs = $scope.fullscreen = !$scope.fullscreen;
            const e = setupFs(fs);
            if (fs) {
				requestFullscreen(e);
			} else {
				exitFullscreen();
			}
			return false;
		};

		function isFullscreen() {
			return !!(document.fullscreenElement
				|| document['mozFullScreenElement']
				|| document['webkitFullscreenElement']
				|| document['msFullscreenElement']);
		}

		const fsMethods = ['requestFullscreen', 'webkitRequestFullscreen', 'mozRequestFullScreen', 'msRequestFullscreen'];
		$scope.hasFullScreen = false;
        const docElem = document.documentElement;
        for(const method of fsMethods) {
			if (docElem[method]) {
				$scope.hasFullScreen = true;
				break;
			}
		}

		function requestFullscreen(elem: Element) {
			for(const method of fsMethods) {
				if (method in elem) {
					elem[method]();
					return true;
				}
			}
			return false;
		}

        const onfullscreenchange: any = () => {
            // has the user exited fullscreen (without using the full screen button
            // maybe by pressing esc, or swiping out of fullscreen
            $scope.$apply(() => {
                const fs = isFullscreen();
                console.log('onfullscreenchange', fs);
                $scope.fullscreen = fs;
                setupFs(fs);
                $scope.closeSearch && $scope.closeSearch();
            });

            // do nothing otherwise
        };

        document.addEventListener('fullscreenchange', onfullscreenchange);
		document.addEventListener('webkitfullscreenchange', onfullscreenchange);
		document.addEventListener('mozfullscreenchange', onfullscreenchange);
		document.addEventListener('MSFullscreenChange', onfullscreenchange);

		function exitFullscreen() {
			if ('exitFullscreen' in document) document.exitFullscreen();
			else if ('webkitExitFullscreen' in document) document['webkitExitFullscreen']();
			else if ('mozCancelFullScreen' in document) document['mozCancelFullScreen']();
			else if ('msExitFullscreen' in document) document['msExitFullscreen']();
			else return false;
			return true;
		}

		$scope.zoomTo = (center : Coordinate, zoom: number = 5) => {
			mapService.promise.then(() => {
				if (mapService.map && mapService.map.getView()) {
                    const view = mapService.map.getView();
                    const duration = 1000;
                    view.animate({
						center,
						zoom,
						duration
					});
				}

			})
		};

		let currentUrl = window.location.pathname + window.location.search;
		$scope.$on("$locationChangeSuccess", () => {
            const prefix = currentUrl + "#";
            const links = document.querySelectorAll(`[href^="${prefix}"]`);
            const newUrl = window.location.pathname + window.location.search;
            for(let i=0; i < links.length; i++) {
                const link = links.item(i);
                const href = link.getAttribute('href');
                link.setAttribute('href', newUrl + "#" + href.substring(prefix.length));
			}
			currentUrl = newUrl;
		});

		$scope.nodeIsIncluded = (node: Item) : boolean => {
			return node && (node.extraState.metaLayerSelector.checked);
		};

		$scope.flattenedLayers = (nodes: Item[]) : Item[] => {
            const res = [];
            nodes.forEach((n) => {
				if (n.checkBehavior == "UNION_SUB") {
					res.push(...n.children);
				} else {
					res.push(n);
				}
			});
			return res;
		};

		$scope.isIndeterminate = (node: Item) => {
			if (!node || !node.children) {
				return false;
			}

            const items = filterNodes(node.children, (n) => n.layer);

            const someAreChecked = items.some((n) => n.checked);
            const someAreNotChecked = items.some((n) => !n.checked);

            return someAreChecked && someAreNotChecked;
		};

		$scope.isBaseLayer = (node: Item) => node && node.layerType === L.layer.Type.BASE && !node.isCustom;

		mapService.promise.then(() => {
			$scope.items = [];
			$scope.checked = this.checked;

			// not sure if the following even does anything, see app-page.ts
			$scope.treeOptions = {
				nodeChildren: "children",
				dirSelectable: true,
				injectClasses: {
					ul: "a1",
					li: "a2",
					liSelected: "a7",
					iExpanded: "a3",
					iCollapsed: "a4",
					iLeaf: "a5",
					label: "a6",
					labelSelected: "a8"
				}//,
				//templateUrl: "/angular-tree-control.html" // see app-page.ts for this configured properly!
			};

			let legendPaneOpened = 0;

			$scope.showSelected = (node: L.tree.Item, selected: boolean, showLegend:boolean=false, silent:boolean = false) => {
				node.click(node);
				$scope.selectedNode = node;
                const index = $scope.expandedNodes.indexOf(node);
                if (index === -1) {
					$scope.expandedNodes.push(node);
				}

				if (!silent) $rootScope.$broadcast(GeoAppEvents.layerToggled, node);

				if (!node.checked) {
					$scope.expandedNodes.splice(index, 1);
				}

                const newScienceLayer = L.tree.getVisibleScienceLayer(node.rootItems);
                if (newScienceLayer != visibleScienceLayer) {
					if (!silent) $rootScope.$broadcast('scienceLayer', { oldValue : visibleScienceLayer, newValue : newScienceLayer });

					visibleScienceLayer = newScienceLayer;
				}

				this.changeStateForActiveLayers(node, visibleScienceLayer);

				if (!silent) {
					$timeout(() => {
						this.showLegendAndMetaData(node).then(() => {
							// open the legend and metadata pane if we're in desktop mode.
							if (node.checked && showLegend && legendPaneOpened < 1) {
                                const paneKey = appConfig.getContainingPane('Legend');
                                const legendPaneWasClosed = $scope[paneKey];
                                $scope[paneKey] = false;
								// track the number of times the legend pane has been forced open by this method
								if (legendPaneWasClosed) legendPaneOpened+= 1;
							}
						}, err => {
							console.error(err);
						});
					}, 0);
				}

				// Log the event
				if (!silent) usageLoggingService.logAction("TOGGLE_LAYER");
			}

			this.showLegendAndMetaData();

			$scope.nodeToggle = L.tree.nodeToggle;

			searchService.setMapService(mapService);
            const search: L.view.GeoSearch = new L.view.GeoSearch($location.search());
            this.initControls($scope, $window, search);
		});


		$scope.$on(GeoAppEvents.showLegendAndMetadata, (ev, item: L.tree.Item) => {
			console.log(GeoAppEvents.showLegendAndMetadata, ev);
			this.showLegendAndMetaData(item);
		});

		this.initModals();
		this.initMessages();
		this.initSaveState();
		$scope.hideElement = (selector: string) => {
			const elements = $window.document.querySelectorAll(selector);
			for (let i = 0; i < elements.length; ++i) {
				elements.item(i).classList.add('hidden');
			}
		};
		$scope.browserSupported = () => {
			const agent = window.navigator.userAgent.toLowerCase();
			const browsers = [/chrome/i, /firefox/i, /safari/i];
			if (browsers.some(browser => !!agent.match(browser))) {
				return true;
			}
			if (agent.match(/Trident/i) && agent.match(/rv:11\.0/i)) {
				return true;
			}
			if (agent.match(/internet explorer/i)) {
				return Number(window.navigator.appVersion.split(' ')[0]) >= 11;
			}
			return false;
        };


		$scope.isTourLoading = () => this.tourService.isTourLoading();
		$scope.startTour = () => this.tourService.startTour();

        // throw new Error('An engular ERROR');
        const reportParam = $location.search()['savedReport'];
        if (reportParam) {
            $rootScope.$broadcast('showFragReport', reportParam);
        }
		// throw new Error('time for error');
	}
	initMessages(): void {
        const mapService = this.mapService;
        // If the layer isn't visible at the map's current zoom level,
		// display a toast warning.

		mapService.mapPromise.then((map) => {
			let msg = null;
			let previousMsg = null;
			let previousToast: IToast;
			const uniqueId = 'layerVisibilityToast';
            const layersHandler = () => {
                msg = null;
                const currentScale = this.getCurrentScale();
                const layersWithMinOrMaxScaleSmallerOrLarger = getVisibleLayers(mapService.treeData)
                    .map((n) => n.layerService)
                    .filter((i) => i)
                    .filter(l => (l.maxScale && currentScale > l.maxScale) || (l.minScale && currentScale < l.minScale));
                const smallerLayers = layersWithMinOrMaxScaleSmallerOrLarger.filter(l => l.minScale && currentScale < l.minScale);
                const largerLayers = layersWithMinOrMaxScaleSmallerOrLarger.filter(l => l.maxScale && currentScale > l.maxScale);
                if (layersWithMinOrMaxScaleSmallerOrLarger.length > 1) {
                    if (smallerLayers.length && largerLayers.length) {
                        msg = "Some layers become visible when zoomed in/out";
                    } else if (smallerLayers.length) {
                        msg = "Some layers become visible when zoomed out";
                    } else if (largerLayers.length) {
                        msg = "Some layers become visible when zoomed in";
                    }
                } else if (layersWithMinOrMaxScaleSmallerOrLarger.length === 1) {
                    const ls = layersWithMinOrMaxScaleSmallerOrLarger[0];
                    const description = ls.description;
                    if (ls.maxScale && currentScale > ls.maxScale) {
                        msg = sprintf(
                            _t('App.ZOOM_GT_LAYER_MAXSCALE', "%s become visible when zoomed in"),
                            description,
							formatScale(ls.maxScale)
                        );
                    } else if (currentScale < ls.minScale) {
                        msg = sprintf(
                            _t('App.ZOOM_LT_LAYER_MINSCALE', "%s is unsuitable for mapping above %s"),
                            description,
							formatScale(ls.minScale)
                        );
                    }
                }

                if (msg && msg === previousMsg) {
                    return;
                }

                if (msg) {
                    previousToast = {
                        message: msg,
                        extraClass: '',
                        duration: undefined,
                        uniqueId
                    }
                    this.toastService.persistentToast = previousToast;

                } else if (this.toastService.persistentToast && this.toastService.persistentToast.uniqueId === uniqueId) {
                    this.toastService.persistentToast = null;
                }
                previousMsg = msg;
            };
            layersHandler();
            const changeHandler = () => {
                const zoom = map.getView().getZoom();
                if (zoom === Math.round(zoom)) {
                    layersHandler();
                }
            };
            map.getView().on('change:resolution', changeHandler);
			map.getLayers().forEach((l) => l.on('change:visible', changeHandler));

			map.getLayers().on('add', (ev: CollectionEvent) => {
				changeHandler();
				ev.element.on('change:visible', changeHandler);
			});

			this.$scope.$on(GeoAppEvents.treeChange, layersHandler);
		});
	}
	zoomLevelAsScale(zoomLevel: number): number {
		return zoomLevel <= (this.$scope.scales.length -1) && zoomLevel >= 0 ?
			this.$scope.scales[zoomLevel] : NaN;
	}
	getCurrentScale(): number {
		return this.zoomLevelAsScale(this.mapService.map.getView().getZoom());
	}
	initControls($scope: IGeoAppScope, $window: ng.IWindowService, search: L.view.GeoSearch): void {
		$scope.scales = [
			10000, 25000, 50000, 100000, 250000, 500000,
			1000000, 2000000, 4000000, 8000000
		];

		$scope.currentScale = $scope.scales[search.getZoom() || $scope.scales.length - 1];
		$scope.zoomToScale = (scale: number) => {
			$scope.currentScale = scale;
			$scope.$emit('ol-zoom-scale', scale, $scope.scales);
		};
        const scalesReversed = $scope.scales.reverse();
        let lastValidZoom = 0;
		//let lowestZoom = 0;
        const highestZoom = 9;

        function closest(n, high) {
			return Math.abs(high - n) > (high / 2) ? 0 : high;
		}

		$scope.$root.$on('mapZoomChanged', (event, zoom) => {
			//let index = ($scope.scales.length - 1) - zoom;
			//console.log('scale zoom', zoom);
			lastValidZoom = isNaN(zoom) ? closest(zoom, highestZoom) : zoom;
			//console.log('mapZoomChanged', zoom)
			$scope.currentScale = scalesReversed[lastValidZoom];
			$scope.$apply();
		})
	}
	checked(node: L.tree.Item): boolean {
		return node && node.isChecked();
	}
	showLegendAndMetaData(node: L.tree.Item = null): ng.IPromise<any> {
        const td = this.mapService.treeData;

        const $scope = this.$scope;
        let nodes;
		if (node) {
			if (!node.isCustom && nodeIsScienceLayer(node)) {
				nodes = _F.flatMap(getVisibleScienceLayers(td), L.tree.getAllCheckedNodes);
			} else if (node.parent && nodeIsScienceLayer(node.parent)) {
				nodes = L.tree.getAllCheckedNodes(node.parent);
			} else {
				nodes = L.tree.getAllCheckedNodes(node);
			}

		} else {
            const defaultLegendOn = this.mapService.configuration && this.mapService.configuration.defaultLegendOn;
            const layerId = defaultLegendOn && defaultLegendOn.layerConfigurationId;

            let myNode;
			if (layerId) {
				myNode = $scope.dataForTheTree.map((n) => n.children).reduce((a, b) => a.concat(b), []).filter((n) => n.layerId === 171)[0];
			}
			nodes = myNode ? [myNode] : [];
		}


		if (!nodes.length) {
			nodes = _F.flatMap(getVisibleScienceLayers(td).concat(
				getVisibleLayers(td).filter(
					layer => layer.layerService &&
					layer.layerService.layerName === 'smap_polys_anno')),
				L.tree.getAllCheckedNodes);
		}

		if (!nodes.length) {
            const visible = getVisibleLayers(td)
                .filter((n) => !n.isCustom);
            nodes = visible.filter((n) => n.layerType == L.layer.Type.CONTEXT);


			if (!nodes.length) {
				nodes = visible.filter((n) => n.layerType == L.layer.Type.BASE);
			}
		}

        const deferred = this.$q.defer();
        const resolveIfTruthy = (result) => {
            if ((result instanceof Array && result.length) || (result && !(result instanceof Array))) {
                deferred.resolve();
            }
        };
        this.showLegend(nodes).then(resolveIfTruthy);
		this.$scope.metadataNodes = nodes;
		return deferred.promise;
	}
	static getQueryItems(legendString: string): ClassType[] {
		return legendString.split(',').map((i) => i.split('|')).map((i) => {
            return {
                'id': i[0],
                'type': i[1]
            };
        });
	}
	showLegendFromShare(legendString: string): ng.IPromise<any> {
        const visibleLayers = L.tree.getVisibleLayers(this.$scope.dataForTheTree);
        const queryItems = GeoAppCtrl.getQueryItems(legendString);
        return this.showLegend(visibleLayers, queryItems)
			.then((node) => {
				if (node) {
					return this.showMetaData([node]);
				} else {
					return this.showLegendAndMetaData();
				}

			}, () => {
				return this.showLegendAndMetaData();
			});
	}
	showLegend(nodes:  L.tree.Item[], queryItems: ClassType[] = null): ng.IPromise<L.tree.Item> {
        const layerIdToNode = {};
        const $scope = this.$scope;
        $scope.legend.items = [];

		const isLocalOrCustom = (n: Item) => n && (n.isCustom || n.isLocalData);

        const allAreCustom = nodes.length && nodes.filter((n) => n).every(n => isLocalOrCustom(n) || isLocalOrCustom(n.parent));

        const newQueryItems = nodes
            .filter((n) => n && (n.classId || n.layerId))
            .filter((n) => !isLocalOrCustom(n))
			.filter(n => !isLocalOrCustom(n.parent))
            .map((n) => {
                const isClass = !!n.classId;
                if (!isClass) {
                    layerIdToNode["" + n.layerId] = n;
                }
                return {
                    'type': (n.classId ? 'class' : 'configuration'),
                    'id': (n.classId ? n.classId : n.layerId)
                };
            });

        queryItems = queryItems || newQueryItems;

		if (!queryItems.length) {
			if (allAreCustom) {
				return this.showCustomLayerLegend(nodes);
			}
			/*console.warn('no layer nodes selected');*/
			return this.$q.reject(new Error('No layer nodes selected'));
		}
		$scope.processingLegend = true;
		$scope.legendQueryItems = queryItems;
		//this.showLegendForQueryItems(queryItems, nodes);
        const $http = this.$http;
        const byClassesOrConfigurationUrl = '/services/portal_configuration/layer_configuration_class';
        return $http({
			url: byClassesOrConfigurationUrl,
			method: 'POST',
			data: {
				request: {
					items: queryItems
				}
			},
			headers: {
				'Content-Type': 'application/json'
			}
		}).then((data: any) => {
			$scope.processingLegend = false;
			const collection = Array.isArray(data.data.response)
				? _F.uniqueBy(data.data.response || [], f => f.id) as any[]
				: data.data.response as any;

			if (collection.noResults || !collection.some((i) => i.shortName)) {
				$scope.legend.items = [
					{
						shortName: 'There is currently no legend available for this layer.',
						longName : ""
					}
				];
				return null;
			}
			let myNode = null;
			$scope.legend.items = collection.filter((c) => {
				return c.legendOn;
			}).map((c) => {
                const classId = c['id'];
                let node = nodes.filter((n) => n.classId && n.classId === classId)[0];
				if (!node) {
					node = layerIdToNode[c['attributes'].layerConfigurationId];
				}
				if (!node) {
					return null;
				}
				if (node.classId) {
					myNode = node.parent;
				} else {
					myNode = node;
				}
				return {
					longName: c.longName,
					shortName: c.shortName,
					iconUrl: node.iconUrl || L.util.Layer.iconFrom(node.layerService, c, true),
					classColor: c.classColor
				}
			}).filter((c) => c && c.shortName); // don't show legend without icons or text

			return myNode;
		});
	}
	showCustomLayerMetaData(nodes: L.tree.Item[]) : any[] {
		return nodes.map((n) => {
			return {
				title: n.name,
				description: paragraphise(n.layerService.longDescription),
				externalLink: null
			};
		});
	}

	showMetaDataFromServices(nodes: L.tree.Item[]) : ng.IPromise<any[]> {
        const $scope = this.$scope;
        //let node = nodes[0]; // hack to let compile TODO: enable for multiple nodes
        const $http = this.$http;
        const url: string = '/services/layer_meta_info/json';
        // let isContext = false; //node.name === 'Context layers';
		$scope.meta.isContext = false;
		//let layerNames = L.tree.findClosestCheckedLayerNames(node);
        const layerNames = L.tree.getLayerNames(nodes);
        if (!layerNames || !layerNames.length) {
			// $scope.meta.items = [];
			return this.$q.reject(new Error('no layers selected')); // nothing to display
		}
		return $http({
			method: 'GET',
			url: url,
			params: {
				layers: layerNames.join(',')
			}
		}).then((data: any) => {
            const response = data.data.response.sort((a, b) => layerNames.indexOf(a.layerName) - layerNames.indexOf(b.layerName));
            console.log('META response', response);
			return response.map((o) => {
				return {
					title: o['title'],
					description: o.description,
					externalLink: o.externalLink
				}
			});
		});
	}

	showMetaData(nodes: L.tree.Item[]): ng.IPromise<any[]> {
        const $scope = this.$scope;

        // filter out null/undefined entries
		nodes = (nodes || []).filter((n) => n);
		if (!nodes.length) {
			$scope.meta.items = [];
			return this.$q.reject(new Error('no layers selected'))
		}

        const customNodes = nodes.filter((n) => n.isCustom);
        const nonCustom = nodes.filter((n) => !n.isCustom);

        const customMeta = this.showCustomLayerMetaData(customNodes);

        return this.showMetaDataFromServices(nonCustom)
			.then((meta) => {
					return meta.concat(customMeta)
				},
				() => customMeta)
			.then((meta) => {
					$scope.meta.items = meta;
					return meta;
			});
	}
	/*showDefaultLegendAndMetaData(node: L.tree.Item): void {
		//console.log('we are at showDefaultLegendMetaData');
		//console.log('node.isChecked() is ' + node.isChecked() + ' AND node.layerType is ' + node.layerType + ' AND node.name is ' + node.name);
		//if (node != undefined && node.isChecked()) {
			//console.log('we are trying to show legend and meta data from showDefaultLegendAndMetaData()');
			let $http = this.$http;
			setTimeout(function(){
				/!* Siamac - we probably need a better solution than this.
				Sleeping for 1 second is not the best solution. Issue due to
				map page haven't loaded yet and waiting for login form to
				disappear. RHS pane has not yet loaded so legend does not get
				updated. *!/

				L.tree.showLegend($http, node);
				L.tree.showMetaData($http, node);
			}, 300); // just sleeping for a bit... so map page is loaded before legend is rendered.

			// Tim's attempt below to refactor code that did not improve code about using timeout.
			//let visible = false;
			/!*
			let checkVisible = () => {
				if (!angular.element('.ol-viewport:visible')) {
					return L.util.Polyfills.requestAnimationFrame(checkVisible);
				}
				L.tree.showLegend(node);
			};
			L.util.Polyfills.requestAnimationFrame(checkVisible);
			*!/
		//}
	}*/
	/*
	findParentNodeScienceLayer($scope: IGeoAppScope, nodes: any): L.tree.Item {
		//console.log('we are at findParentNodeScienceLayer');
		for (let node of nodes) {
			//console.log('node.layerType is ' + node.layerType);
			if (node.layerType === 'SCI_GROUP') {
				$scope.selectedNode = node;
				return node;
			}
		}
	}*/
	initModals(): void {
        const $uibModal = this.$uibModal;
        const $scope = this.$scope;
        const $http = this.$http;

        $scope.open = function() {
            const modal = $uibModal.open({
                animation: true,
                templateUrl: 'app-page/javascript/public/partials/modalSearchResults.html',
                controller: 'modalInstanceCtrl',
                size: 'lg',
                scope: $scope,
                resolve: {
                    items: function () {
                        return $scope.items
                    }
                }
            });
            $scope.closeSearch = () => modal.close();
		};
		$scope.$on('searchAddress', function(event: ng.IAngularEvent, search: string) {
			$scope.items = [];
			$http.get<any>('app/addressSearch/' + search + '?max=100').then((it) => {
				for (const v of it.data) {
					$scope.items.push({
						pxid: v.pxid,
						value: v.a
					});
				}
				$scope.open();
			});
		});
		$scope.$on('searchPlace', (event: ng.IAngularEvent, search: string) => {
			$scope.items = [];
            const url: string = '/services/simple_search/json?max_results=100&epsg=2193&expression=';
            $http.get<any>(url + search).then((it) => {
				$scope.items = it.data.response.map(v => ({
					name: this.$sce.trustAsHtml(v.result),
					x: v.x,
					y: v.y,
					pxid: v.pxid
				}));
				$scope.open();
			});
		});

		$scope.$on('showModal', (evt, view: string, mobile: boolean = true, fullUrl: boolean = false, backdrop: boolean | string = true) => {
			this.showModal(view, mobile, fullUrl, backdrop);
		});
		let viewHistory = [];
		let viewHistoryIndex = -1;
		let doUpdate = true;
		$scope.$on('setLocationCenter', (event, center, zoom) => {
			if (!doUpdate) {
				doUpdate = true;
				return;
			}
			viewHistoryIndex++;
            const item = {
                center: center,
                zoom: zoom
            };
            viewHistory = viewHistory.slice(0, viewHistoryIndex);
			viewHistory.push(item);
			console.log('adding item at', viewHistoryIndex, item);
		});
        const setViewState = () => {
            const viewObj = viewHistory[viewHistoryIndex];
            const view = this.mapService.map.getView();
            doUpdate = false;
            const duration = 1000;
            view.animate({
                center: viewObj['center'],
                zoom: viewObj['zoom'],
                duration: duration
            });
        };
        $scope.historyBack = ($event) => {
			if ($event) $event.preventDefault();
			--viewHistoryIndex;
			if (viewHistoryIndex < 0) {
				viewHistoryIndex = 0;
			}
			setViewState();
			return false;
		};
		$scope.historyForward = ($event) => {
			if ($event) $event.preventDefault();
			++viewHistoryIndex;
            const lastIndex = viewHistory.length - 1;
            if (viewHistoryIndex > lastIndex) {
				viewHistoryIndex = lastIndex;
			}
			setViewState();
			return false
		};

		$scope.hasHistoryBack = () => viewHistoryIndex > 0;
		$scope.hasHistoryForward = () => viewHistoryIndex < viewHistory.length - 1;

		$scope.refreshPage = ($event) => {
			if ($event) $event.preventDefault();
			$scope.resetMap(undefined);

			filterNodes(this.mapService.treeData, n => !!n.layer)
				.forEach((n: Item) => {
					n.checked = !!n.layer.get('isDefaultLayer');

					// $scope.showSelected(n, n.checked, false, true);
					this.layerTreeManipulationService.toggleLayer(n, n.checked, { silent: true, showLegend: false });
				});

			this.$state.go(StateNames.base, {});

			/*
			const isOrHasDefaultChildren = (n: Item) => {
				if (n.children && n.children.length) {
					return someNodes(n.children, isOrHasDefaultChildren);
				}

				return n.layer && n.layer.get('isDefaultLayer');
			};*/

			// $scope.expandedNodes = filterNodes(this.mapService.treeData, isOrHasDefaultChildren);

			$scope.$root.$broadcast(GeoAppEvents.treeChange);

			return false;
		};

		$scope.$on(GeoAppEvents.resetMapAndLayers, $scope.refreshPage);
		$scope.$on(GeoAppEvents.resetMapAndLayers, () => $scope.$root.$broadcast(GeoAppEvents.removeUnsavedPins));
	}
	showShareReportModal() : void {
		this.showShareModal('modalMapShare.html', 'Share this report', 'report');
	}
	showShareModal(view : string = 'modalMapShare.html', title : string = 'Share this map', modalType : string = 'share') : void {
        const $scope = this.$scope;
        const uibModalInstance = this.$uibModal.open({
			animation: true,
			templateUrl: 'app-page/javascript/public/partials/' + view,
			controller: 'modalInstanceCtrl',
			size: 'lg',
			scope: $scope,
			appendTo : elemToAppendModal(),
			resolve: {
				items: function() {
					return $scope.items
				}
			}
		});

        uibModalInstance.result.catch(() => {});

        $scope.modalType = () => modalType;
		$scope.modalTitle = () => title;
		$scope.closeSearch = () => {
			uibModalInstance.close();
		};

    }
	showModal(view: string, mobile: boolean=true, fullUrl: boolean = false, backdrop: boolean | string = true): boolean {
		this.usageLoggingService.logWithAnalytics('GeoAppCtrl', 'showModal', 'view');
        const $scope = this.$scope;
        let templateUrl = view;
		if (!fullUrl) {
			templateUrl = 'app-page/javascript/public/partials/modal' + view + (mobile ? 'Mobile' : '') + '.html'
		}

        const uibModalInstance = this.$uibModal.open({
            animation: true,
            backdrop,
            templateUrl: templateUrl,
            controller: 'modalInstanceCtrl',
            size: 'lg',
            keyboard: true,
            scope: $scope,
            appendTo: elemToAppendModal(),
            resolve: {
                items: function () {
                    return $scope.items
                }
            }
        } as any);
        let accepted = view.indexOf('Terms') === -1;
		$scope.closeSearch = () => {
			uibModalInstance.close();
		};
		$scope.closeSearchAndAccept = () => {
			$scope.closeSearch();
			accepted = true;
			window.localStorage.setItem('termsShown', '1');
			$scope.$root.$broadcast('termsAccepted');
		};
		$scope.clearSearchAndCloseSearch = () => {
			$scope.clearSearch();
			$scope.closeSearch();
			//uibModalInstance.close();
		};
		uibModalInstance.closed.then(() => {
			if (!accepted) {
				window.localStorage.removeItem('termsShown'); // force showing terms again!
				// The following was used to redirect in case of not accepted terms.
				// However, it is not needed because of the static backdrop.
				//document.location.href = '/help/terms-of-use';
			}
		});

		// we ignore dismissals, just catching the error
		uibModalInstance.result.catch(() => { });

		return accepted;
	}
	getLegendString(): string {
        const s = this.$scope.legendQueryItems
            .reduce((acc, item) => acc + item.id + '|' + item.type + ',', '');
        return s.substring(0, s.length - 1);
	}
	locationChangeListener() {
		let currentUrl = window.location.pathname + window.location.search;
		this.$scope.$on("$locationChangeSuccess", () => {
            const prefix = currentUrl + "#";
            const links = document.querySelectorAll(`[href^="${prefix}"]`);
            const newUrl = window.location.pathname + window.location.search;
            for(let i=0; i < links.length; i++) {
                const link = links.item(i);
                const href = link.getAttribute('href');
                link.setAttribute('href', newUrl + "#" + href.substring(prefix.length));
			}
			currentUrl = newUrl;
		});
	}
	onLocationChange() {
		this.mapService.mapPromise.then((map) => {
            const qString = this.qString;
            const $location = this.$location;
            const search = qString.parseKeyValue(document.location.search.substring(1));
            if (!search['c']) {
				return;
			}
            const z = search['z'] || '8';
            const center = search['c'].split(',').map((a) => Number(a));
            const zoom = Number(z);
            const duration = 1000;
            map.getView().animate({
				center,
				zoom,
				duration
			}, function() {
				console.log('end animate');
				//setTimeout(()=>window.history.replaceState(null,null,location.pathname), 1000);
				$location.search({});
			});
		});
	}
	initSaveState(): void {
		const terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
		window.addEventListener(terminationEvent, () => {
			console.log('view', this.mapService.view);

            const legend = this.getLegendString();
            const payload = this.mapShareService.createSharePayload(null, legend);
            sessionStorage.setItem('mapState', JSON.stringify(payload));
		});

		this.locationChangeListener();
		this.onLocationChange();
	}
	changeStateForActiveLayers(node: Item, visibleScienceLayer: Item, customTransitionOptions: any = {}): void {
		let contextLayers = "";

		const contextLayerNodes = getVisibleLayers(this.layerTreeManipulationService.treeData)
			.filter(n => n.layerType === "CONTEXT");

		const layerIds = new Set(
			contextLayerNodes
				.map(n => n.layerService && n.layerService.layerName)
				.filter(id => !!id)
		);

		if (node.layerType === "CONTEXT") {
			if (node.checked) {
				layerIds.add(node.layerService.layerName);
			} else {
				layerIds.delete(node.layerService.layerName);
			}
		}

		contextLayers = Array.from(layerIds).join(',');

		if (visibleScienceLayer) {
			const group = visibleScienceLayer.parent.name;
			const visibleLayers = L.tree.getVisibleScienceLayers(visibleScienceLayer.rootItems);
			const layers = visibleLayers.map(n => n.layerService.layerName).join(',');

			const groupTypes = ["SCI_GROUP"/*, "SCI_GROUP_CLASS_UNCHECKABLE"*/];
			const classes = visibleLayers.filter(l => groupTypes.includes(l.layerService.type))
				.map(layer => layer.children || [])
				.map(children => children.filter(cl => cl.isChecked()))
				.flat(1)
				.map(cl => cl.classId)
				.join(',');

			if (classes.length) {
				const stateParams: IStateLayerParams = {
					group,
					layers,
					classes,
					contextLayers
				};
				this.$state.go(StateNames.layersWithClasses, stateParams, { custom: customTransitionOptions });
			} else {
				const stateParams: IStateLayerParams = {
					group,
					layers,
					contextLayers
				};
				this.$state.go(StateNames.layers, stateParams, { custom: customTransitionOptions });
			}
		} else if(node) {
			const group = node.parent;
			if (someNodes(group, nodeIsScienceLayer) && group.expanded) {
				this.$state.go(StateNames.group, { group: group.name, contextLayers });
			} else {
				this.$state.go(StateNames.base, { contextLayers });
			}
		}
	}

	private showCustomLayerLegend(nodes: L.tree.Item[]) : ng.IPromise<L.tree.Item> {
        const def = this.$q.defer<L.tree.Item>();

        const fixUrl = (url: string): string => {
			if (!url || url.indexOf('?') === -1) return url;

            const qs = url.substr(url.indexOf('?') + 1);

            const params = this.qString.parseKeyValue(qs);
            if (params['request'] === 'GetLegendGraphic') {
                params['height'] = 60;
                params['width'] = 60;

                return url.substr(0, url.indexOf('?') + 1) + this.qString.toKeyValue(params);
            }

            return url;
        };


        const simpleIconLegend = (n: L.tree.Item) => {
            return [{
				shortName: n.name || n.parent.name,
				longName: "",
				get graphicUrl() {
					return fixUrl(n.iconUrl)
				}
			}]
		};

		const esriLegend = (node: L.tree.Item) => {
			const legend = node.layerService.esriLegend;
			return [
					{
						shortName: legend.layerName,
						longName: ""
					},
					...legend.legend.map(cls => {
						return {
							shortName: cls.label,
							longName: "",
							graphicUrl: `data:${cls.contentType};base64,${cls.imageData}`
						}
					})
				]

		};

		const iconItems = [
				...(new Set(filterNodes(nodes, n => n.iconUrl || (n.layerService && n.layerService.esriLegend))))
			]
			.map((n) => {
				if (n.iconUrl) {
					return simpleIconLegend(n);
				} else if (n.layerService && n.layerService.esriLegend) {
					return esriLegend(n);
				}
				return null;
			})
			.reduce((acc, items) => acc.concat(items), []);

		this.$scope.legend.items = iconItems.length ? iconItems : [
			{
				shortName: 'No legend available.',
				longName : ""
			}
		];

		def.resolve(nodes[0]);

		return def.promise;
	}
}
